const ActionType = {
  // Login action types
  LOGIN_ERROR: 'LOGIN_ERROR',
  PASSWORD_ERROR: 'PASSWORD_ERROR',
  OPERATION_INPROGRESS: 'OPERATION_INPROGRESS',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  RESET_SUCCESS: 'RESET_SUCCESS',
  LOGOUT: 'LOGOUT',
  UPDATE_USER: 'UPDATE_USER',
  LOGIN_AS_CUSTOMER: 'LOGIN_AS_CUSTOMER',
  LOGIN_AS_COMPANY: 'LOGIN_AS_COMPANY',
  UPDATE_USER_VISITED_PAGE: 'UPDATE_USER_VISITED_PAGE',

  // Patient ActionType
  PATIENT_LIST: 'PATIENT_LIST',
  COMPANY_PATIENT_LIST: 'COMPANY_PATIENT_LIST',
  SET_PATIENT_SEARCH: 'SET_PATIENT_SEARCH',
  SET_PATIENT_SCHEDULE_VIEW: 'SET_PATIENT_SCHEDULE_VIEW',
  SERVICE_ERROR: 'SERVICE_ERROR',
  PATIENT_INPROGRESS: 'PATIENT_INPROGRESS',
  ROW_SELECT: 'ROW_SELECT',
  NOTIFY: 'NOTIFY',
  MAIL: 'MAIL',
  STATS: 'STATS',
  CASESTATS: 'CASE_STATS',
  SET_PATIENT: 'SET_PATIENT',
  SET_PATIENT_ROM: 'SET_PATIENT_ROM',
  SET_ACTIVITIES: 'SET_ACTIVITIES',
  SET_MEASUREMENTS: 'SET_MEASUREMENTS',
  SET_NEW_PATIENT: 'SET_NEW_PATIENT',
  SET_PAT_NT: 'SET_PAT_NT',
  SET_PAT_ACTIVITYLOG:'SET_PAT_ACTIVITYLOG',
  SET_PAT_ISACTIVE:'SET_PAT_ISACTIVE',
  SET_SURGERY_TYPES: 'SET_SURGERY_TYPES',
  SET_FILTER: 'SET_FILTER',
  SET_DEFAULT_FILTER: 'SET_DEFAULT_FILTER',
  SET_ACTIVE_DEVICES:'SET_ACTIVE_DEVICES',

  // Surgeon ActionType
  SURGEON_LIST: 'SURGEON_LIST',
  SURGEONS: 'SURGEONS',
  SURGEON_ERROR: 'SURGEON_ERROR',
  SURGEON_SELECT: 'SURGEON_SELECT',
  SET_SURGEON: 'SET_SURGEON',

  // Feedback ActionType
  FEEDBACK_FORMS: 'FEEDBACK_FORMS',
  FEEDBACK_GRAPH: 'FEEDBACK_GRAPH',
  FEEDBACK_ERROR: 'FEEDBACK_ERROR',
  FEEDBACK_EDIT: 'FEEDBACK_EDIT',
  ADD_FEEDBACK_FORM: 'ADD_FEEDBACK_FORM',

  // User ActionType
  USER_LIST: 'USER_LIST',
  USER_INPROGRESS: 'USER_INPROGRESS',

  //Action cases
  CASES_INPROGRESS: 'CASES_INPROGRESS',
  CASES_LIST: 'CASES_LIST',
  CASES_PATIENT_LIST: 'CASES_PATIENT_LIST',
  CASE_EDIT: 'CASE_EDIT',
  SINGLE_MESSAGE:'SINGLE_MESSAGE',
  SET_PATIENT_AND_MESSAGE:'SET_PATIENT_AND_MESSAGE',
  CASE_HEALTH_COACH_NAME_LIST: 'CASE_HEALTH_COACH_NAME_LIST',
  CASE_PATIENT_LASTDIGIT_LIST: 'CASE_PATIENT_LASTDIGIT_LIST',

  //Reg ActionType
  REG_INPROGRESS: 'REG_INPROGRESS',
  REG_SET_ASSIGNED: 'REG_SET_ASSIGNED',
  REG_SET_FILTERS: 'REG_SET_FILTERS',
  REG_SET_REGS: 'REG_SET_REGS',

  //DEVICE ActionType
  DEVICE_INPROGRESS: 'DEVICE_INPROGRESS',
  DEVICE_SET_ASSIGNED: 'DEVICE_SET_ASSIGNED',
  DEVICE_SET_FILTERS: 'DEVICE_SET_FILTERS',
  DEVICE_SET_DEVICE: 'DEVICE_SET_DEVICE',
  DEVICE_SET_PLANS: 'DEVICE_SET_PLANS',
  PLAN_SET_ASSIGNED: 'PLAN_SET_ASSIGNED',
  DEVICE_SET_FULLFILLMENTS: 'DEVICE_SET_FULLFILLMENTS',
  DEVICE_SET_FULLFILLMENT_DEVICES: 'DEVICE_SET_FULLFILLMENT_DEVICES',
  DEVICE_SET_FULLFILLMENTS_COUNT: 'DEVICE_SET_FULLFILLMENTS_COUNT',
  DEVICE_SET_FULLFILLMENT_FILTER: 'DEVICE_SET_FULLFILLMENT_FILTER',
  DEVICE_LOCATION:'DEVICE_LOCATION',

  // Schedule Action Types
  SCHED_INPROGRESS: 'SCHED_INPROGRESS',
  SCHED_SET_EXERCISES: 'SCHED_SET_EXERCISES',
  SCHED_SET_SELECTED: 'SCHED_SET_SELECTED',

  // Exercises Action Types
  EXER_INPROGRESS: 'EXER_INPROGRESS',
  EXER_SET_EXERCISES: 'EXER_SET_EXERCISES',

  // Customer ActionType
  CUSTOMER_LIST: 'CUSTOMER_LIST',
  CUSTOMER_INPROGRESS: 'CUSTOMER_INPROGRESS',

  // Company ActionType
  COMPANY_LIST: 'COMPANY_LIST',
  COMPANY_INPROGRESS: 'COMPANY_INPROGRESS',

  //Messages ActionType
  MESSAGE_INPROGRESS: 'MESSAGE_INPROGRESS',
  MESSAGE_LIST: 'MESSAGE_LIST',
  MESSAGE_ROW_SELECT: 'MESSAGE_ROW_SELECT',
  MESSAGE_NEW: 'MESSAGE_NEW',
  MESSAGE_SERVICE_ERROR: 'MESSAGE_SERVICE_ERROR',
  MESSAGE_SELECT_BOX: 'MESSAGE_SELECT_BOX',
  MESSAGE_GROUP_BY: 'MESSAGE_GROUP_BY',
  MESSAGE_FILTER: 'MESSAGE_FILTER',

  FULLFILLMENT_ROW_SELECT: 'FULLFILLMENT_ROW_SELECT',
  //Events ActionType
  EVENT_SERVICE_ERROR: 'EVENT_SERVICE_ERROR',
  SET_EVENTS: 'SET_EVENTS',
  EVENTS_INPROGRESS: 'EVENTS_INPROGRESS',
  SET_SURGERY_TYPE: 'SET_SURGERY_TYPE',
  SET_EVENT_UPDATED: 'SET_EVENT_UPDATED',
  SET_EVENT_DIFFERENCES: 'SET_EVENT_DIFFERENCES',
  SET_CHANGED_EVENTS: 'SET_CHANGED_EVENTS',
  SET_ISUPDATE: 'SET_ISUPDATE',
  SET_TEMP_EVENTS: 'SET_TEMP_EVENTS',

  // Notification Action
  WEBNOTIFICATION_INPROGRESS: 'NOTIFICATION_INPROGRESS',
  WEBNOTIFICATION_SERVICE_ERROR: 'NOTIFICATION_SERVICE_ERROR',
  SET_WEBTOKEN: 'SET_WEBTOKEN',
  WEBNOTIFICATION_SERVICE_SUCCESS: 'NOTIFICATION_SERVICE_SUCCESS',

  // Patient Notes Action Types
  GET_PATIENT_NOTES_START: 'GET_PATIENT_NOTES_START',
  GET_PATIENT_NOTES_SUCCESS: 'GET_PATIENT_NOTES_SUCCESS',
  GET_PATIENT_NOTES_FAILURE: 'GET_PATIENT_NOTES_FAILURE',
  GET_PATIENT_NOTES_CATEGORIES_START: 'GET_PATIENT_NOTES_CATEGORIES_START',
  GET_PATIENT_NOTES_CATEGORIES_SUCCESS: 'GET_PATIENT_NOTES_CATEGORIES_SUCCESS',
  GET_PATIENT_NOTES_CATEGORIES_FAILURE: 'GET_PATIENT_NOTES_CATEGORIES_FAILURE',
  ADD_PATIENT_NOTE_START: 'ADD_PATIENT_NOTE_START',
  ADD_PATIENT_NOTE_SUCCESS: 'ADD_PATIENT_NOTE_SUCCESS',
  ADD_PATIENT_NOTE_FAILURE: 'ADD_PATIENT_NOTE_FAILURE',
  UPDATE_PATIENT_NOTE_START: 'UPDATE_PATIENT_NOTE_START',
  UPDATE_PATIENT_NOTE_SUCCESS: 'UPDATE_PATIENT_NOTE_SUCCESS',
  UPDATE_PATIENT_NOTE_FAILURE: 'UPDATE_PATIENT_NOTE_FAILURE',
  DELETE_PATIENT_NOTE_START: 'DELETE_PATIENT_NOTE_START',
  DELETE_PATIENT_NOTE_SUCCESS: 'DELETE_PATIENT_NOTE_SUCCESS',
  DELETE_PATIENT_NOTE_FAILURE: 'DELETE_PATIENT_NOTE_FAILURE',
  GET_PATIENT_NOTES_COUNT_START: 'GET_PATIENT_NOTES_COUNT_START',
  GET_PATIENT_NOTES_COUNT_SUCCESS: 'GET_PATIENT_NOTES_COUNT_SUCCESS',
  GET_PATIENT_NOTES_COUNT_FAILURE: 'GET_PATIENT_NOTES_COUNT_FAILURE',

  // Patient Diagnoses Action Types
  GET_PATIENT_DIAGNOSES_START: 'GET_PATIENT_DIAGNOSES_START',
  GET_PATIENT_DIAGNOSES_SUCCESS: 'GET_PATIENT_DIAGNOSES_SUCCESS',
  GET_PATIENT_DIAGNOSES_FAILURE: 'GET_PATIENT_DIAGNOSES_FAILURE',

  // Billing Action Types
  GET_BILLING_DATA_START: 'GET_BILLING_DATA_START',
  GET_BILLING_DATA_SUCCESS: 'GET_BILLING_DATA_SUCCESS',
  GET_BILLING_DATA_FAILURE: 'GET_BILLING_DATA_FAILURE',

  // Settings Action Types
  SETTINGS_INPROGRESS: 'SETTINGS_INPROGRESS',
  SETTINGS_CLINIC_LOADED: 'SETTINGS_CLINIC_LOADED',
  SETTINGS_RESOLVED_LOADED: 'SETTINGS_RESOLVED_LOADED',
}

export default ActionType
